import React from 'react';
import { Table } from 'react-bootstrap';

function renderFunctionValueSelect(functionName, functionValues, params, domain, onChange, disabled) {
  let value = functionValues[JSON.stringify(params)];

  if (!value) {
    value = '';
  }

  return /*#__PURE__*/React.createElement("select", {
    onChange: e => onChange(params.concat([e.target.value]), functionName),
    value: value
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, ''), domain.map(item => /*#__PURE__*/React.createElement("option", {
    key: item,
    disabled: disabled,
    value: item
  }, item)));
}

function permutateWithRepetitions(permutationOptions, permutationLength) {
  if (permutationLength === 1) {
    return permutationOptions.map(permutationOption => [permutationOption]);
  } // Init permutations array.


  const permutations = []; // Get smaller permutations.

  const smallerPermutations = permutateWithRepetitions(permutationOptions, permutationLength - 1); // Go through all options and join it to the smaller permutations.

  permutationOptions.forEach(currentOption => {
    smallerPermutations.forEach(smallerPermutation => {
      permutations.push([currentOption].concat(smallerPermutation));
    });
  });
  return permutations;
}

function DatabaseFunction(props) {
  let domain = [...props.domain];
  let domainValueArray = Object.values(domain);
  let mainElement = /*#__PURE__*/React.createElement("tbody", null, permutateWithRepetitions(domainValueArray, props.arity).map((arrayValues, count) => /*#__PURE__*/React.createElement("tr", {
    key: "database-function-row" + count
  }, arrayValues.map((value, index) => /*#__PURE__*/React.createElement("td", {
    key: "database-function-row-" + count + "-item-" + index
  }, value)), /*#__PURE__*/React.createElement("td", null, renderFunctionValueSelect(props.name, props.value, [...arrayValues], domain, props.onInputChange, props.disabled)))));
  let headElements = /*#__PURE__*/React.createElement("th", null, props.symbol + "(", [...Array(props.arity - 1)].map((x, count) => /*#__PURE__*/React.createElement("span", {
    key: "database-function-header-parameter-" + count
  }, /*#__PURE__*/React.createElement("var", null, "m"), /*#__PURE__*/React.createElement("sub", null, count + 1), ", ")), /*#__PURE__*/React.createElement("span", {
    key: "database-function-header-parameter-last"
  }, /*#__PURE__*/React.createElement("var", null, "m"), /*#__PURE__*/React.createElement("sub", null, props.arity)), ")");
  return /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    responsive: true,
    size: "sm",
    className: "small"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, [...Array(props.arity)].map((x, count) => /*#__PURE__*/React.createElement("th", {
    key: "database-function-header" + count
  }, /*#__PURE__*/React.createElement("var", null, "m"), /*#__PURE__*/React.createElement("sub", null, count + 1))), headElements)), mainElement);
}

export default DatabaseFunction;